/* SCUM — comportamiento de la tienda. Sin dependencias.
   · hover front/back en retícula y SHOP (seco, sin transición)
   · galería del producto con puntos
   · ADD TO CART sin recargar, BUY NOW → checkout
   · pop-up FUCK EMAIL
*/
(function () {
  'use strict';

  var hasCursor = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var routes = { cartAdd: '/cart/add.js', cart: '/cart.js', checkout: '/checkout' };

  /* ── carrito ───────────────────────────────────────────── */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !(n > 0); });
  }

  function addToCart(id, qty) {
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'ERROR'); });
      return fetch(routes.cart, { headers: { 'Accept': 'application/json' } }).then(function (c) { return c.json(); });
    }).then(function (cart) { setCount(cart.item_count); return cart; });
  }

  function flash(el, text) {
    if (!el) return;
    el.textContent = text;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.textContent = ''; }, 1800);
  }

  /* ── hover front → back ────────────────────────────────── */
  if (hasCursor) {
    document.querySelectorAll('[data-swap-a][data-swap-b]').forEach(function (a) {
      var img = a.querySelector('img');
      if (!img) return;
      var srcA = a.getAttribute('data-swap-a'), srcB = a.getAttribute('data-swap-b');
      var srcsetA = img.getAttribute('srcset'), sizesA = img.getAttribute('sizes');
      var pre = new Image(); pre.src = srcB;                 // precarga: el cambio es seco
      a.addEventListener('mouseenter', function () { img.removeAttribute('srcset'); img.src = srcB; });
      a.addEventListener('mouseleave', function () { img.src = srcA; if (srcsetA) img.setAttribute('srcset', srcsetA); if (sizesA) img.setAttribute('sizes', sizesA); });
    });
  }

  /* ── lookbook: carrusel por pieza ─────────────────────── */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var link = root.querySelector('.look-link');
    if (!track) return;
    var count = track.children.length;
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { i = (i + count) % count; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function paint() { var i = index(); dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
    dots.forEach(function (d) { d.addEventListener('click', function (e) { e.preventDefault(); go(Number(d.getAttribute('data-dot'))); }); });
    root.querySelectorAll('[data-arrow]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(index() + Number(b.getAttribute('data-arrow'))); }); });
    track.addEventListener('scroll', paint, { passive: true });
    // paso automático cada 5 s, cada lote con su propio desfase al azar
    var PERIOD = 12000, JITTER = 4000, hold = 0;   // ritmo sutil, nunca sincronizado
    if (count > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var step = function () {
        if (!document.hidden && Date.now() >= hold) go(index() + 1);
        setTimeout(step, PERIOD + (Math.random() - 0.5) * JITTER);
      };
      setTimeout(step, 2000 + Math.random() * PERIOD);
      root.addEventListener('pointerdown', function () { hold = Date.now() + 8000; }, { passive: true });
      root.addEventListener('touchstart', function () { hold = Date.now() + 8000; }, { passive: true });
      root.addEventListener('mouseenter', function () { hold = Infinity; });
      root.addEventListener('mouseleave', function () { hold = 0; });
    }
    // un deslizamiento no cuenta como clic hacia el producto
    var x0 = 0;
    if (link) {
      link.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
      link.addEventListener('click', function (e) { if (Math.abs(e.clientX - x0) > 8) e.preventDefault(); });
    }
  });

  /* ── producto ──────────────────────────────────────────── */
  var pdp = document.querySelector('[data-product]');
  if (pdp) {
    var imgs = Array.prototype.slice.call(pdp.querySelectorAll('.frame-img'));
    var dots = Array.prototype.slice.call(pdp.querySelectorAll('[data-dot]'));
    var cur = 0;
    function show(i) {
      if (!imgs.length) return;
      cur = (i + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('on', k === cur); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
    }
    show(0);
    dots.forEach(function (d) { d.addEventListener('click', function () { show(Number(d.getAttribute('data-dot'))); }); });
    var gallery = pdp.querySelector('[data-gallery]');
    if (gallery && imgs.length > 1) {
      // móvil: se pasa de foto deslizando el dedo (no tocando la imagen)
      var sx = 0, sy = 0, tracking = false;
      gallery.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; tracking = true; }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (!tracking) return; tracking = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
      // escritorio (ratón): el clic sobre la foto sigue avanzando
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        gallery.style.cursor = 'pointer';
        gallery.addEventListener('click', function () { show(cur + 1); });
      }
    }

    // variantes
    var form = pdp.querySelector('#product-form');
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-price]');
    var addBtn = pdp.querySelector('[data-add]');
    var buyBtn = pdp.querySelector('[data-buy-now]');
    var flashEl = pdp.querySelector('[data-flash]');
    var variants = [];
    try { variants = JSON.parse(pdp.querySelector('[data-variants]').textContent); } catch (e) {}
    var selects = Array.prototype.slice.call(pdp.querySelectorAll('[data-option]'));

    var fmt = pdp.getAttribute('data-money-format') || '${{amount}}';
    var soldOut = pdp.getAttribute('data-sold-out') || 'SOLD OUT';
    function money(cents) {
      var n = cents / 100;
      var s = fmt
        .replace('{{amount_no_decimals}}', Math.round(n).toLocaleString('en-US'))
        .replace('{{amount}}', n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
        .replace('{{amount_with_comma_separator}}', n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(n).toLocaleString('de-DE'));
      return s.replace(/<[^>]+>/g, '');
    }

    function pickVariant() {
      if (!selects.length || !variants.length) return null;
      var chosen = selects.map(function (s) { return s.value; });
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); }) || null;
    }

    function syncVariant() {
      var v = pickVariant();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.available ? money(v.price) : soldOut;
      var tb = pdp.querySelector('[data-terms-big]');
      if (tb) { var n = (v.price >= 5000 && v.price < 100000) ? 4 : (v.price >= 3500 && v.price < 5000) ? 2 : 0; tb.hidden = !n; if (n) tb.textContent = n + ' × ' + money(Math.round(v.price / n)); }
      [addBtn, buyBtn].forEach(function (b) { if (b) b.disabled = !v.available; });
      // deja la URL con la variante elegida (compartible)
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }
    selects.forEach(function (s) { s.addEventListener('change', syncVariant); });

    // cantidad
    var qty = 1;
    var qtyVal = pdp.querySelector('[data-qty-value]'), qtyInput = pdp.querySelector('[data-qty-input]');
    pdp.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.min(9, Math.max(1, qty + Number(b.getAttribute('data-qty'))));
        if (qtyVal) qtyVal.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addBtn.disabled = true;
        addToCart(idInput.value, qty)
          .then(function () { flash(flashEl, 'ADDED'); })
          .catch(function (err) { flash(flashEl, String(err.message || err).toUpperCase()); })
          .then(function () { addBtn.disabled = false; });
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        buyBtn.disabled = true;
        addToCart(idInput.value, qty)
          .then(function () { location.href = routes.checkout; })
          .catch(function (err) { flash(flashEl, String(err.message || err).toUpperCase()); buyBtn.disabled = false; });
      });
    }
  }

  /* ── BUY NOW desde SHOP (una sola variante) ────────────── */
  document.querySelectorAll('[data-buy-now][data-variant-id]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      addToCart(b.getAttribute('data-variant-id'), 1)
        .then(function () { location.href = routes.checkout; })
        .catch(function () { b.disabled = false; });
    });
  });

  /* ── pop-up ────────────────────────────────────────────── */
  var popup = document.querySelector('[data-popup]');
  if (popup) {
    var once = popup.getAttribute('data-once') === 'true';
    var store = once ? window.localStorage : window.sessionStorage;
    var key = 'scum_popup';
    var seen = false;
    try { seen = store.getItem(key) === '1'; } catch (e) {}
    function close() { popup.hidden = true; try { store.setItem(key, '1'); } catch (e) {} }

    /* Justificación del cartel: FUCK EMAIL marca el ancho; el botón se
       estira a ese ancho exacto y NOW WE SCUM se escala (tracking fijo)
       hasta ocupar de borde a borde el mismo ancho. */
    function justifyPopup(box) {
      var head = box.querySelector('.popup-head'), sub = box.querySelector('.popup-sub'), btn = box.querySelector('.btn');
      if (!head || !sub || !btn) return;
      var W = head.getBoundingClientRect().width;
      if (!W) return;
      btn.style.width = W + 'px'; btn.style.padding = '0';
      sub.style.letterSpacing = '0'; sub.style.fontSize = '10px';
      var per = sub.getBoundingClientRect().width / 10;         // ancho por px de cuerpo, sin tracking
      var n = sub.textContent.trim().length, t = 0.2;            // tracking 0.2em
      var fs = W / (per + t * (n - 1));
      sub.style.fontSize = fs.toFixed(2) + 'px';
      sub.style.letterSpacing = t + 'em';
    }

    if (!seen) setTimeout(function () { popup.hidden = false; justifyPopup(popup); }, Number(popup.getAttribute('data-delay') || 5) * 1000);
    window.addEventListener('resize', function () { if (!popup.hidden) justifyPopup(popup); });
    popup.querySelectorAll('[data-popup-close]').forEach(function (el) { el.addEventListener('click', close); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });
  }
})();
